var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18050_52293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38889 16.5V11.4444C6.38889 10.6467 7.03559 10 7.83333 10H12.1667C12.9644 10 13.6111 10.6467 13.6111 11.4444V16.5M8.55556 12.8889H11.4444M4.94444 16.5H15.0556C15.8533 16.5 16.5 15.8533 16.5 15.0556V4.94444C16.5 4.1467 15.8533 3.5 15.0556 3.5H7.70942C7.32633 3.5 6.95893 3.65218 6.68804 3.92307L3.92307 6.68804C3.65218 6.95893 3.5 7.32633 3.5 7.70942V15.0556C3.5 15.8533 4.1467 16.5 4.94444 16.5Z",
    stroke: "#002CFB",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18050_52293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/iconSave.935bebc051de9dbf21bc4b9a9883a13a.svg";
export { ForwardRef as ReactComponent };